import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { concatWithDot } from 'helpers/string';

import { SolvencyFormHeader } from './components/SolvencyFormHeader';
import { SolvencyFormTable } from './components/SolvencyFormTable';
import { SOLVENCY_FORM_NAMES } from './utils/form';
import { FullScreenWrapper } from '../../components/FullScreenWrapper';
import { solvencyFormPrefix } from '../utils/form';

import styles from './Solvency.module.scss';

const FormComponent = ({ disabled }: { disabled: boolean }) => {
  return (
    <>
      <SolvencyFormHeader disabled={disabled} />
      <SolvencyFormTable disabled={disabled} />
    </>
  );
};

export const SolvencyForm: FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  const isDisabled = !canAccess;
  const inputFieldName = concatWithDot(solvencyFormPrefix, SOLVENCY_FORM_NAMES.ANTICIPATED_OUTCOME);
  return (
    <>
      <FormSectionCard title={t('financialPlan.financialPerformance.solvency.tableDescription')} disabled={isDisabled}>
        <Box className={styles.content}>
          <FullScreenWrapper title={t('financialPlan.financialPerformance.solvency.tableDescription')}>
            <FormComponent disabled={isDisabled} />
          </FullScreenWrapper>
          <FormSectionCard
            title={t('financialPlan.financialPerformance.solvency.anticipatedOutcome')}
            disabled={!canAccess}
            aiFieldName={inputFieldName}
          >
            <TextInputControl
              multiline
              control={control}
              id={inputFieldName}
              name={inputFieldName}
              minRows={3}
              disabled={isDisabled}
              maxLength={1500}
            />
          </FormSectionCard>
        </Box>
      </FormSectionCard>
    </>
  );
};
